export default __webpack_public_path__ + "media/images/avatars/avatar13-74654e1b94519aa2e6d291e67a3f914c.png";